var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-350b4003.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-42970741.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a34.717 34.717 0 0 1-.337 5.316H.325a34.916 34.916 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a30.81 30.81 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "m3.307 3.307 7.36 7.36v10.666l-7.36 7.36C1.39 26.63.868 24.123.868 24.123c-.698-2.79-.897-5.615-.864-8.14-.033-2.493.2-5.318.863-8.109 0 0 .524-2.505 2.441-4.568Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagKwt = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagKwt_default = SvgFlagKwt;
export {
  FlagKwt_default as default
};
